import { render, staticRenderFns } from "./CaseDetailsData.vue?vue&type=template&id=6e4a2a4c&scoped=true"
import script from "./CaseDetailsData.vue?vue&type=script&lang=js"
export * from "./CaseDetailsData.vue?vue&type=script&lang=js"
import style0 from "./CaseDetailsData.vue?vue&type=style&index=0&id=6e4a2a4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4a2a4c",
  null
  
)

export default component.exports